import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import initializeAuthentication from './firebase/firebase.init';
import {useState} from "react";


initializeAuthentication();
const provider = new GoogleAuthProvider();

function App() {
  const [user, setUser] = useState({});

const handleGoogleSignIn = () => {
  const auth = getAuth();
  signInWithPopup(auth, provider)
  .then(result => {
    const user = result.user;
    setUser(user);
    document.title='welcome'
  }) .catch ((error) => {
    console.log(error.message);
  })
};

function handleSignOut() {
  setUser({});
  document.title='watch store'
}
function purchaseLog() {
  fetch("https://majestic-cairn-365919.uk.r.appspot.com/"+user.email)
  .then(console.log('logged'))
  .catch((error) => {
    console.log('spring.mongo')
  })
}
  
  return (
    <div className="App">
          
      <button onClick={handleGoogleSignIn}>Google Sign In</button> <br/>
      
      {
        user.email && (
          <div>
            <h2>
              Welcome to the Store! {user.displayName}
            </h2>
            <div id="logOut">
            <button onClick={handleSignOut}>Log Out</button>
            </div>
            <img src={user.photoURL} alt=""/>
            <br/>
        <br/>
        <br/>
        <button onClick={purchaseLog}>Add to Wish</button>
            </div>
        )
      }
      {
        Object.keys(user).length === 0 && (
          <div>
            <h2>
              Home Store Page!
            </h2>
            <br/>
            <img src="https://images.unsplash.com/photo-1472851294608-062f824d29cc?ixlib=
            rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=200&q=260" alt='open'>
        </img>
            </div>

        )
      }
    </div>
  );
}

export default App;
